<template>
  <div class="PastRespondents" v-if="selectedStudy && currentTab">
    <h2 class="left-align">View Past Respondent Files</h2>
    <ul>
      <li class="p3 left-align">
        The Username and Password files generated previously for this study, if
        any, are available below.
      </li>
      <br />
      <li class="p3 left-align">
        Also available are import files reflecting the settings chosen for
        respondent accounts created using the wizard. The wizard-generated files
        can be used for subsequent manual uploads of additional accounts or new
        dates, if desired. This file can be modified and manually uploaded to
        update the schedule of recalls and attempts if necessary.
      </li>
      <br />
      <li class="p3 left-align">
        Select on the file name to download and save that file.
      </li>
      <br />
    </ul>
    <div>
      <v-simple-table>
        <thead>
          <tr>
            <th class="data-table-header">File Name</th>
            <th class="data-table-header">File Contains</th>
            <th class="data-table-header">File Creation Date</th>
            <th class="data-table-header">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(file, i) in fileList" :key="file.fileName + i">
            <td class="left-align">
              <v-btn
                text
                @click="downloadFile(file.fileName)"
                class="btn-link-left"
                >{{ file.fileName }}</v-btn
              >
            </td>
            <td class="left-align">{{ file.fileType }}</td>
            <td class="left-align">{{ getFormattedDate(file.dateRecorded) }}</td>
            <td class="left-align">
							<v-btn text @click="onDeleteFile(file)" class="btn-link-left">
								Delete
							</v-btn>
            </td>
          </tr>
        </tbody>
        <tbody v-if="!fileList.length">
          <tr>
            <td colspan="4">No Data Available</td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
		<foe-dialog v-model="showDeleteDialog" :dialogW="showDeleteDialog" persistent max-width="600px" class="cancel-dialog" >
			<v-card class="reset-respondent-password-card">
				<v-card-title  class="text-h5 text-center"> Confirm Delete </v-card-title>
				<v-card-text v-if="fileToDelete && fileToDelete.fileName">Are you sure you want to delete this file: {{ fileToDelete.fileName }}</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn class="btn-default" text @click="showDeleteDialog = false">
						No
					</v-btn>
					<v-btn
						class="btn-default"
						text
						:loading="isDeletingFile"
						@click="deleteRespondentFile()"
					>
						Yes
					</v-btn>
				</v-card-actions>
			</v-card>
		</foe-dialog>
  </div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService.js';
import { utilityService } from '@/services/utilityService.js';
export default {
	name: 'PastRespondents',
	props: {},
	data: () => ({
		fileList: [],
		studyUuid: '',
		showDeleteDialog: false,
		fileToDelete: null,
		isDeletingFile: false
	}),
	mounted () {},
	computed: {
		selectedStudy: function () {
			// If the selectedStudy changes, the radio buttons and checkbox properties need to be updated.
			if (this.studyUuid !== this.$store.getters.getSelectedStudy.studyUuid) {
				this.updateSelected();
			}
			return this.$store.getters.getSelectedStudy;
		},
		currentTab: function () {
			const tabPosition = {
				tabIndex: parseInt(this.$store.getters.getCurrentStudyTabIndex),
				subTabIndex: parseInt(this.$store.getters.getCurrentStudySubTabIndex)
			};

			this.checkTabMatch(tabPosition);

			return tabPosition;
		}
	},
	methods: {
		updateSelected () {
			this.studyUuid = this.$store.getters.getSelectedStudy.studyUuid;
			this.loadData();
		},
		loadData () {
			const me = this;

			researcherApiService
				.loadRespondentFiles(this.studyUuid)
				.then(function (response) {
					if (response && response.data) {
						for (var i = 0; i < response.data.length; i++) {
							if (response.data[i].fileType === 'SCHEDULE') {
								response.data[i].fileType = 'Wizard Created Schedule Files';
							} else {
								response.data[i].fileType = 'User Names and Passwords'
							}
						}
						me.fileList = response.data;
					}
				});
		},
		downloadFile (fileName) {
			const me = this;
			researcherApiService
				.loadFile(this.studyUuid, fileName)
				.then(function (response) {
					if (response) {
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', fileName);
						document.body.appendChild(link);
						link.click();
					}
				}).catch(function (error) {
					// Show an error message to the user
					me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'generic-error', message: 'There was an error downloading the file.' });
				});
		},
		async checkTabMatch ({ tabIndex, subTabIndex } = {}) {
			var tabsPos = await utilityService.getTabsPositionByName(
				'View Past Respondent Files',
				this.$studyTabConfig
			);
			if (
				tabsPos.tabPos === tabIndex &&
        tabsPos.subtabPos === subTabIndex
			) {
				this.loadData();
			}
		},
		onDeleteFile (file) {
			this.showDeleteDialog = true;
			this.fileToDelete = file;
		},
		deleteRespondentFile () {
			const me = this;
			this.isDeletingFile = true;
			researcherApiService
				.deleteFile(this.studyUuid, this.fileToDelete.fileName)
				.then(function () {
					me.loadData();
				})
				.then(function (response) {
					me.showDeleteDialog = false;
					me.isDeletingFile = false;
					me.$store.dispatch(
						'changeUpdateStatus',
						{ status: 'delete-respondents-success' }
					);
				})
				.catch(function (e) {
					me.showDeleteDialog = false;
					me.isDeletingFile = false;
					let errorMessage = 'Deleting Respondents file failed.';
					if (e.response.data.messages) {
						errorMessage = e.response.data.messages[0];
					}
					me.$store.dispatch('changeUpdateStatusWithMessage', {
						status: 'delete-respondents-fail',
						message: errorMessage
					});
				});
		},
		getFormattedDate (date) {
			if (date && date.length) {
				return utilityService.formatDateTime(date)
			}

			return 'N/A';
		}
	}
};
</script>

<style>
</style>
